import { useEffect } from "react";
import { useQuill } from "react-quilljs";
import BlotFormatter from "quill-blot-formatter";
import "quill/dist/quill.snow.css";

interface EditorProps {
  handleButtonClick: (editorContent: string) => void;
  initialContent: string;
}

const Editor = ({ handleButtonClick, initialContent }: EditorProps) => {
  const { quill, quillRef, Quill } = useQuill({
    modules: { blotFormatter: {} },
  });

  if (Quill && !quill) {
    Quill.register("modules/blotFormatter", BlotFormatter);
  }

  useEffect(() => {
    if (quill && quill.root.innerHTML !== initialContent) {
      quill.clipboard.dangerouslyPasteHTML(initialContent);

      quill.on("text-change", () => {
        handleButtonClick(quill.root.innerHTML);
      });
    }
  }, [quill, initialContent]);

  return (
    <div>
      <div ref={quillRef} />
    </div>
  );
};

export default Editor;
